import React from "react";
import TextField from "@material-ui/core/TextField";
import PropTypes from "prop-types";

const advanceFocus = () => {
  // increment focus to next focusable element
  const focusableElements = document.querySelectorAll(
    'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
  );
  let idx = 0;
  // theres probably a better way to check which is the next element
  focusableElements.forEach((ele, i) => {
    if (ele === document.activeElement) {
      idx = i;
      return;
    }
  });
  focusableElements[(idx + 1) % focusableElements.length].focus();
};

const TextFieldAdvanceOnEnter = props => {
  const { onEnter, ...otherProps } = props;
  return (
    <TextField
      {...otherProps}
      onKeyPress={event => {
        if (event.key === "Enter") {
          event.preventDefault();
          onEnter();
        }
      }}
    />
  );
};

TextFieldAdvanceOnEnter.propTypes = {
  onEnter: PropTypes.func
};

TextFieldAdvanceOnEnter.defaultProps = {
  onEnter: advanceFocus
};

export default TextFieldAdvanceOnEnter;
